import type { GameEvent } from '../types';

export const events: GameEvent[] = [
  {
    id: 'army_eikthyr',
    tier: 1,
    icon: 'Eikthyr',
    biomes: ['Meadows', 'BlackForest'],
    killed: [],
    notKilled: ['Eikthyr'],
    altItemsNot: ['PickaxeAntler', 'PickaxeBronze', 'PickaxeIron', 'HardAntler', 'TrophyEikthyr'],
    altPlayerKeysNot: ['GP_Eikthyr'],
    duration: 90,
    spawns: [
      {
        id: 'Neck',
        max: 2,
        interval: 20,
      },
      {
        id: 'Boar',
        max: 2,
        interval: 20,
      }
    ],
    base: true,
  },
  {
    id: 'army_theelder',
    tier: 2,
    icon: 'gd_king',
    biomes: ['Meadows', 'BlackForest', 'Swamp', 'Plains'],
    killed: ['Eikthyr'],
    notKilled: ['gd_king'],
    altItems: ['PickaxeAntler', 'PickaxeBronze', 'PickaxeIron', 'HardAntler', 'TrophyEikthyr'],
    altItemsNot: ['TrophyTheElder', 'CryptKey'],
    altPlayerKeys: ['GP_Eikthyr'],
    altPlayerKeysNot: ['GP_TheElder'],
    duration: 120,
    spawns: [
      {
        id: 'Greydwarf',
        max: 6,
        interval: 5,
      },
      {
        id: 'Greydwarf_Shaman',
        max: 1,
        interval: 5,
      },
      {
        id: 'Greydwarf_Elite',
        max: 1,
        interval: 5,
      },
    ],
    base: true,
  },
  {
    id: 'foresttrolls',
    tier: 2,
    icon: 'Troll',
    biomes: ['Meadows', 'BlackForest', 'Swamp', 'Plains'],
    killed: ['gd_king', 'Troll'],
    notKilled: [],
    altItems: ['TrophyTheElder', 'CryptKey'],
    altPlayerKeys: ['KilledTroll'],
    duration: 80,
    spawns: [
      {
        id: 'Troll',
        max: 2,
        interval: 20,
      }
    ],
    base: true,
  },
  {
    id: 'army_bonemass',
    tier: 3,
    icon: 'Bonemass',
    biomes: ['Meadows', 'BlackForest', 'Swamp', 'Mountain', 'Plains'],
    killed: ['gd_king'],
    notKilled: ['Bonemass'],
    altItems: ['TrophyTheElder', 'CryptKey'],
    altItemsNot: ['TrophyBonemass', 'Wishbone'],
    altPlayerKeys: ['GP_TheElder'],
    altPlayerKeysNot: ['GP_Bonemass'],
    duration: 150,
    spawns: [
      {
        id: 'Draugr',
        max: 3,
        interval: 5,
      },
      {
        id: 'Skeleton',
        max: 3,
        interval: 5,
      },
    ],
    base: true,
  },
  {
    id: 'skeletons',
    tier: 4,
    icon: 'Skeleton',
    biomes: ['Meadows', 'BlackForest', 'Swamp', 'Plains', 'Mistlands'],
    killed: ['Bonemass'],
    altItems: ['TrophyBonemass', 'Wishbone'],
    altPlayerKeys: ['GP_Bonemass'],
    notKilled: [],
    duration: 120,
    spawns: [
      {
        id: 'Skeleton',
        max: 20,
        group: [4, 6],
        interval: 10,
      },
      {
        id: 'Skeleton_Poison',
        max: 1,
        interval: 15,
        chance: 0.54,
      },
    ],
    base: true,
  },
  {
    id: 'surtlings',
    tier: 4,
    icon: 'Surtling',
    biomes: ['Meadows', 'BlackForest', 'Swamp', 'Plains'],
    killed: ['Bonemass', 'Surtling'],
    notKilled: [],
    altItems: ['TrophyBonemass', 'Wishbone'],
    altPlayerKeys: ['killed_surtling'],
    duration: 120,
    spawns: [
      {
        id: 'Surtling',
        max: 4,
        interval: 2,
      }
    ],
    base: true,
  },
  {
    id: 'blobs',
    tier: 4,
    icon: 'Blob',
    biomes: ['Meadows', 'BlackForest', 'Swamp', 'Plains'],
    killed: ['Bonemass'],
    notKilled: [],
    altItems: ['TrophyBonemass', 'Wishbone'],
    altPlayerKeys: ['GP_Bonemass'],
    duration: 120,
    spawns: [
      {
        id: 'Blob',
        max: 5,
        interval: 2,
      },
      {
        id: 'BlobElite',
        max: 2,
        interval: 2,
      }
    ],
    base: true,
  },
  {
    id: 'army_moder',
    tier: 4,
    icon: 'Dragon',
    biomes: ['Meadows', 'BlackForest', 'Swamp', 'Mountain', 'Plains'],
    killed: ['Bonemass'],
    notKilled: ['Dragon'],
    altItems: ['TrophyBonemass', 'Wishbone'],
    altItemsNot: ['TrophyDragonQueen', 'DragonTear'],
    altPlayerKeys: ['GP_Bonemass'],
    altPlayerKeysNot: ['GP_Moder'],
    duration: 150,
    spawns: [
      {
        id: 'Hatchling',
        max: 3,
        interval: 10,
      }
    ],
    base: true,
  },
  {
    id: 'ghosts',
    tier: 3,
    icon: 'Wraith',
    biomes: ['Meadows', 'BlackForest', 'Swamp', 'Mountain', 'Plains'],
    killed: ['Bonemass'],
    notKilled: ['Dragon'],
    altItems: ['TrophyBonemass', 'Wishbone'],
    altItemsNot: ['TrophyDragonQueen', 'DragonTear'],
    altPlayerKeys: ['GP_Bonemass'],
    altPlayerKeysNot: ['GP_Moder'],
    duration: 150,
    spawns: [
      {
        id: 'Ghost',
        max: 3,
        interval: 10,
      },
      {
        id: 'Wraith',
        max: 2,
        interval: 10,
      },
    ],
    base: true,
  },
  {
    id: 'wolves',
    tier: 4,
    icon: 'Wolf',
    biomes: ['Mountain', 'Plains'],
    killed: ['Bonemass'],
    notKilled: [],
    altItems: ['Wishbone', 'TrophyBonemass'],
    altPlayerKeys: ['GP_Bonemass'],
    duration: 120,
    spawns: [
      {
        id: 'Wolf',
        max: 6,
        interval: 2,
      }
    ],
    base: false,
  },
  {
    id: 'army_goblin',
    tier: 5,
    icon: 'GoblinKing',
    biomes: ['Meadows', 'BlackForest', 'Plains'],
    killed: ['Dragon'],
    notKilled: ['GoblinKing'],
    altItems: ['DragonTear', 'TrophyDragonQueen'],
    altItemsNot: ['TrophyGoblinKing', 'YagluthDrop'],
    altPlayerKeysNot: ['GP_Yagluth'],
    duration: 120,
    spawns: [
      {
        id: 'Goblin',
        max: 8,
        group: [1, 4],
        interval: 10,
        chance: 0.582,
      },
      {
        id: 'GoblinBrute',
        max: 2,
        interval: 20,
        chance: 0.47,
      },
      {
        id: 'GoblinShaman',
        max: 1,
        interval: 20,
        chance: 0.47,
      },
    ],
    base: true,
  },
  {
    id: 'bats',
    tier: 4,
    icon: 'Bat',
    biomes: ['Meadows', 'BlackForest', 'Swamp', 'Mountain', 'Plains'],
    killed: ['Bonemass', 'Bat'],
    notKilled: [],
    altPlayerKeys: ['KilledBat'],
    duration: 120,
    spawns: [
      {
        id: 'Bat',
        max: 10,
        group: [2, 4],
        interval: 10,
        chance: 1,
      },
    ],
    base: true,
  },
  {
    id: 'army_gjall',
    tier: 6,
    icon: 'Gjall',
    biomes: ['Mistlands'],
    killed: ['GoblinKing'],
    notKilled: ['SeekerQueen'],
    altItems: ['YagluthDrop', 'Demister', 'Wisp'],
    altItemsNot: ['QueenDrop'],
    altPlayerKeys: ['$se_yagluth_name'],
    altPlayerKeysNot: ['GP_Queen'],
    duration: 90,
    spawns: [
      {
        id: 'Gjall',
        max: 1,
        interval: 40,
        chance: 1,
      },
      {
        id: 'Tick',
        max: 4,
        interval: 20,
        chance: 1,
      },
    ],
    base: true,
  },
  {
    id: 'army_seekers',
    tier: 6,
    icon: 'Seeker',
    biomes: ['BlackForest', 'Mountain', 'Plains', 'Ocean', 'Mistlands'],
    killed: ['GoblinKing'],
    notKilled: ['SeekerQueen'],
    altItems: ['YagluthDrop', 'Demister', 'Wisp'],
    altItemsNot: ['QueenDrop'],
    altPlayerKeys: ['defeated_queen'],
    altPlayerKeysNot: ['GP_Queen'],
    duration: 120,
    spawns: [
      {
        id: 'Seeker',
        max: 3,
        group: [1, 1],
        interval: 35,
        chance: 1,
      },
      {
        id: 'SeekerBrood',
        max: 8,
        group: [1, 1],
        interval: 20,
        chance: 1,
      },
      {
        id: 'SeekerBrute',
        max: 1,
        group: [1, 1],
        interval: 100,
        chance: 1,
      },
    ],
    base: true,
  },
  {
    id: 'hildirboss1',
    tier: 2,
    icon: 'Skeleton_Hildir',
    biomes: ['Meadows', 'BlackForest', 'Swamp', 'Mountain', 'Plains', 'Ocean', 'Mistlands'],
    killed: ['Skeleton_Hildir'],
    notKilled: [],
    altItems: ['chest_hildir1'],
    altPlayerKeys: ['BossHildir1'],
    duration: 90,
    spawns: [
      {
        id: 'Skeleton_Hildir_nochest',
        max: 1,
        group: [1, 1],
        interval: 100,
        chance: 1,
      },
      {
        id: 'Skeleton',
        max: 4,
        group: [1, 2],
        interval: 20,
        level: [2, 3],
      },
      {
        id: 'Skeleton_Poison',
        max: 1,
        group: [1, 1],
        interval: 100,
        level: [2, 3],
      },
    ],
    base: true,
  },
  {
    id: 'hildirboss2',
    tier: 4,
    icon: 'Fenring_Cultist_Hildir',
    biomes: ['Meadows', 'BlackForest', 'Swamp', 'Mountain', 'Plains', 'Ocean', 'Mistlands'],
    killed: ['Fenring_Cultist_Hildir'],
    notKilled: [],
    altItems: ['chest_hildir2'],
    altPlayerKeys: ['BossHildir2'],
    duration: 90,
    spawns: [
      {
        id: 'Fenring_Cultist_Hildir_nochest',
        max: 1,
        group: [1, 1],
        interval: 100,
        chance: 1,
      },
      {
        id: 'Fenring',
        max: 3,
        group: [1, 2],
        interval: 20,
        level: [2, 3],
      },
      {
        id: 'Fenring_Cultist',
        max: 1,
        group: [1, 1],
        interval: 100,
        level: [2, 3],
      },
    ],
    base: true,
  },
  {
    id: 'hildirboss3',
    tier: 5,
    icon: 'GoblinBruteBros',
    biomes: ['Meadows', 'BlackForest', 'Swamp', 'Mountain', 'Plains', 'Ocean', 'Mistlands'],
    killed: ['GoblinBruteBros'],
    notKilled: [],
    altItems: ['chest_hildir3'],
    altPlayerKeys: ['BossHildir3'],
    duration: 90,
    spawns: [
      {
        id: 'GoblinBruteBros_nochest',
        max: 1,
        group: [1, 1],
        interval: 100,
        chance: 1,
      },
      {
        id: 'Goblin',
        max: 4,
        group: [1, 2],
        interval: 20,
        level: [2, 3],
      },
      {
        id: 'GoblinBrute',
        max: 1,
        group: [1, 1],
        interval: 100,
        level: [2, 3],
      },
    ],
    base: true,
  },
/*  disabled: true,
  {
    id: 'gemgoblin',
    tier: 7,
    icon: 'GemstoneRed',
    biomes: ['BlackForest', 'Plains', 'Mistlands', 'Ashlands', 'DeepNorth'],
    killed: ['Fader'],
    notKilled: ['SeekerQueen'],
    altItems: [],
    altPlayerKeys: [],
    duration: 90,
    spawns: [
      {
        id: 'Goblin_Gem',
        max: 3,
        group: [1, 1],
        interval: 35,
        chance: 1,
      },
    ],
    base: false,
  }, */
  {
    id: 'army_charred',
    tier: 7,
    icon: 'Charred_Melee',
    biomes: ['BlackForest', 'Plains', 'Mistlands', 'Ashlands', 'DeepNorth'],
    killed: ['SeekerQueen'],
    notKilled: ['Fader'],
    altItems: [],
    altPlayerKeys: [],
    duration: 90,
    spawns: [
      {
        id: 'Charred_Melee',
        max: 2,
        group: [1, 1],
        interval: 50,
        chance: 1,
      },
      {
        id: 'Charred_Twitcher',
        max: 3,
        group: [1, 1],
        interval: 40,
        chance: 1,
      },
      {
        id: 'Charred_Archer',
        max: 3,
        group: [1, 1],
        interval: 50,
        chance: 1,
      },
    ],
    base: true,
  },
  {
    id: 'army_charredspawners',
    tier: 7,
    icon: 'Charred_Twitcher',
    biomes: ['BlackForest', 'Plains', 'Mistlands', 'Ashlands', 'DeepNorth'],
    killed: ['SeekerQueen'],
    notKilled: ['Fader'],
    altItems: [],
    altPlayerKeys: [],
    duration: 90,
    spawns: [
      {
        id: 'Spawner_CharredStone_event',
        max: 3,
        group: [1, 1],
        interval: 60,
        chance: 1,
      },
      {
        id: 'Charred_Twitcher',
        max: 3,
        group: [1, 1],
        interval: 40,
        chance: 1,
      },
      {
        id: 'Charred_Archer',
        max: 3,
        group: [1, 1],
        interval: 50,
        chance: 1,
      },
    ],
    base: true,
  },
];
